<template slot="body">
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
          <button
            type="button"
            class="btn btn-success btn-with-shadow ml-3"
            @click="openDeleteModal('P', '¿Desea procesar este registro?')"
          >
            Procesar
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form class="mb-0" ref="form">
          <div class="row" v-if="evaluationList && evaluationList.length >= 0">
            <div class="col-12">
              <app-note
                class="pt-2 clearfix"
                :title="$t('Procesos en bloque')"
                content-type="html"
                note-type="note-warning"
                :notes="[
                  $t(
                    'Al realizar o no la aprobación de la propuesta de equipo evaluador se efectuará la misma acción para las siguientes evaluaciones o testificaciones'
                  ),
                ]"
              />
            </div>
            <br />
            <div class="col-12">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th scope="col">Expediente</th>
                    <th scope="col">Tipo</th>
                    <th scope="col">Código</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, key) in evaluationList" :key="key">
                    <td class="align-middle">
                      {{ value.accreditation_applications.record }}
                    </td>
                    <td class="align-middle">
                      <br />
                      <p v-if="value.type == 'E'">Evaluación</p>
                      <p v-if="value.type == 'T'">Testificación</p>
                    </td>
                    <td class="align-middle">{{ value.code }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-6" v-if="inputs.request_signed">
              <div class="form-group text-center">
                <p class="card-title m-0">
                  <strong>Solicitud de Acreditación</strong>
                </p>
                <br />
                <a
                  :href="inputs.request_signed"
                  class="btn btn-success"
                  target="_blank"
                >
                  <app-icon name="file" />
                </a>
              </div>
            </div>
            <div class="col-6" v-if="fileUrl">
              <div class="form-group text-center">
                <p class="card-title m-0">
                  <strong>Propuesta de Equipo Evaluador</strong>
                </p>
                <br />
                <a :href="fileUrl" class="btn btn-success" target="_blank">
                  <app-icon name="file" />
                </a>
              </div>
            </div>
          </div>

          <div
            class="
              card card-with-shadow
              border-0
              mb-primary
              justify-content-center
              align-items-center
            "
          >
            <div class="form-group row text-center">
              <label for="inputs_name" class="col-sm-12 mb-0">
                <h5 class="card-title m-0">Aprueba el equipo evaluador?</h5>
                <br />
              </label>
              <app-input
                id="inputs_approved"
                class="col-sm-12"
                type="radio-buttons"
                :list="listOptions"
                @input="clicked"
                v-model="inputs.approved"
              />
            </div>
          </div>

          <!--<div class="form-group row text-center" v-if="inputs.approved == 1">
            <label for="inputs_name" class="col-sm-12 mb-0">
              <h5 class="card-title m-0">
                ¿Hay modificaciones en el sistema de gestión del OEC?
              </h5>
              <br />
            </label>
            <app-input
              id="inputs_approved"
              class="col-sm-12"
              type="radio-buttons"
              :list="listOptionsSystem"
              @input="clicked"
              v-model="inputs.system_gestion_modification"
              :required="true"
            />
          </div> -->

          <div class="form-group row align-items-center" v-if="!hide">
            <label for="inputs_name" class="col-sm-12 mb-0">
              <h5 class="card-title m-0">
                Justificación de rechazo del Equipo Evaluador
              </h5>
              <br />
            </label>
            <app-input
              id="inputs_observations"
              class="col-sm-12"
              type="textarea"
              v-model="inputs.observations"
              :required="true"
            />
          </div>
          <div class="card card-with-shadow border-0 mb-primary" v-if="!hide">
            <div class="card-body">
              <div class="form-group mb-primary row align-items-center">
                <div class="col-sm-12">
                  <h5 class="card-title m-0">
                    Documentación Complementaria
                    <span class="text-danger">Opcional</span>
                  </h5>
                  <br />
                  <a
                    v-if="fileUrlComplement"
                    :href="fileUrlComplement"
                    class="btn btn-success"
                    target="_blank"
                  >
                    <app-icon name="file" />
                  </a>
                  <app-input
                    type="file"
                    :label="file"
                    v-model="inputs.attach_rejected"
                    v-on:change="fileChoosen"
                  />
                  <br />
                  <small class="form-text text-muted">Archivo MAX 8MB</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button
                  type="submit"
                  class="btn btn-primary btn-sm"
                  @click="saveObservationsDisaproved()"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="col-12" v-if="hide">
        <legend class="text-primary">Documentación para la {{nameDocByAccType}}</legend>
      </div>

      <div class="col-12" v-if="hide">
        <div
          class="row mb-2"
          v-for="(vj, j) in management_system_file"
          :key="j"
        >
          <div class="col-12 col-md-5" v-if="!vj.annexed">
            <app-input
              :id="`file_${j}`"
              type="file"
              :label="vj.file ? vj.file.name : $t('upload_your_file')"
              v-model="vj.file"
              @change="onChange($event, j)"
            />
            <small v-if="!vj.annexed" class="text-center text-danger"
              >Tamaño máximo del archivo 8 Mb</small
            >
          </div>
          <div class="col-12 col-md-6" v-if="vj.annexed">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openFileTab(vj.annexed)"
            >
              <app-icon name="file" /> Ver
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal(j, vj)"
            >
              <app-icon name="trash-2" /> Eliminar
            </button>
          </div>

          <div class="col-12 col-md-5" v-if="vj.annexed">
            <app-input
              :id="`filename_${j}`"
              type="text"
              v-model="vj.filename"
              placeholder="Descripcion del archivo"
              @keyup="onKeyUp(j)"
            />
            <small v-if="!vj.filename" class="text-center text-danger"
              >Es necesario agregar una descripción</small
            >
          </div>

          <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
            <button
              type="submit"
              class="btn btn-warning"
              @click="removeRowFile(j)"
              v-if="!vj.annexed"
            >
              Quitar
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <button type="submit" class="btn btn-primary" @click="addFile()">
              <app-icon name="plus" /> Agregar archivo
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="hide">
      <legend class="text-primary"></legend>
    </div>
    <div class="col-12" v-if="hide">
      <legend class="text-primary"></legend>
    </div>
    <!--
    <div class="row" v-if="hide">
      <button
        v-if="hide"
        type="button"
        class="btn btn-success btn-with-shadow ml-3"
        @click="saveTransaction"
      >
        Guardar
      </button>
    </div>
    -->
    <app-confirmation-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="modal-confirm-id"
      @confirmed="process"
      @cancelled="cancelled"
      title="Confirmación"
      :message="deleteTitle"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />

    <app-overlay-loader v-if="preloader" />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosPost, axiosDelete } from "@/app/helpers/AxiosHelper";
import * as actions from "../../../../apiUrl";

export default {
  name: "ProformaModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    id: String,
    accreditation_id: String,
  },
  data() {
    return {
      isAddEditModalActive: false,
      preloader: false,
      inputs: {
        observations: null,
        request_signed: null,
      },
      evaluationList: [],
      hide: true,
      fileUrl: "",
      fileUrlComplement: "",
      showModalInput: false,
      file: "Seleccionar Archivo",
      modalId: "team-id-modal",
      modalTitle: this.$t("add"),
      accreditationId: String,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      listOptionsSystem: [
        {
          id: "2",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
      listOptions: [
        {
          id: "2",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
      management_system_file: [],
    };
  },
  created() {
    this.modalTitle = this.$t("Aceptar u Objetar Equipo");
    this.getInfo();
    this.getObservations();
  },
  methods: {
    getInfo() {
      this.preloader = true;
      let url = `/accreditations/process/evaluationInfo/${this.id}`;
      this.axiosGet(url)
        .then((response) => {
          console.log(response.data);
          // SECTIONS FOR VIEW (approved_evaluation_team)
          switch (response.data.approved_evaluation_team) {
            case 0:
              // NO APROBADO
              this.inputs.approved = 2;
              this.hide = false;
              this.showModalInput = false;
              break;
            case 1:
              // APROBADO
              this.inputs.approved = 1;
              this.hide = true;
              this.showModalInput = true;
              break;
          }
          this.nameDocByAccType = response.data.accreditation_applications.accreditation_type.name;
          this.accreditationId = response.data.accreditation_applications.id;
          if (response.status == 200) {
            this.management_system_file = response.data.management_system_file;
            console.log(this.management_system_file);
          }
          if (
            response.data.evaluationList &&
            response.data.evaluationList.length >= 0
          ) {
            this.evaluationList = response.data.evaluationList;
            if (response.data.file_evaluation_objetion) {
              this.fileUrlComplement =
                response.data.file_evaluation_objetion.full_url;
            }
          }
          if (response.data.accreditation_applications.request_signed) {
            this.inputs.request_signed =
              response.data.accreditation_applications.request_signed.full_url;
            this.fileUrl = response.data.evaluation_team_file.full_url;
          }
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.preloader = false;
        });
    },

    addFile() {
      if (this.management_system_file.length >= 15) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 15 archivos");
        return;
      }
      this.management_system_file.push({
        record_id: this.id,
        filename: null,
        file: null,
      });
    },

    openFileTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModal(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    removeRowFile(j) {
      this.management_system_file = this.management_system_file.filter(
        (value, index) => index != j
      );
    },

    cancelled() {
      this.deleteModal = false;
    },
    onChange(e, j) {
      const tmp = this.management_system_file[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.management_system_file[j], "file", null);
        this.$set(this.management_system_file[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }
      if (!tmp.filename)
        this.$set(this.management_system_file[j], "filename", "");
      this.chargeFile(j);
    },

    onKeyUp(j) {
      const tmp = this.management_system_file[j];
      if (!tmp.annexed) {
      } else {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
      }
    },
    removeRowFile(j) {
      this.management_system_file = this.management_system_file.filter(
        (value, index) => index != j
      );
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `/accreditations/process/addFileAttachManagementSystemFile`;
      const tmpo = this.management_system_file[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(
        this.management_system_file[j]
      )) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [...this.management_system_file];
            tmp[j] = data;
            this.management_system_file = tmp;
          }
        })
        .catch(({ error }) => {});
    },
    inputAprovedSystemGestion(id, value) {
      const url = `${actions.ACCREDITATION_PROCESS}/accreditation/changeGestionSystemFiles/${id}/${value}`;
      this.axiosGet(url)
        .then((res) => {})
        .catch(({ error }) => {});
    },
    // 0 = NO  ;  1 = YES  => BD
    clicked(event) {
      if (this.inputs.approved === "2") {
        const url = `${actions.ACCREDITATION_PROCESS}/accreditation/approvedEvalTeam/${this.id}/0`;
        this.axiosGet(url)
          .then((res) => {})
          .catch(({ error }) => {});
        this.inputAprovedSystemGestion(this.id, "1");

        this.hide = false;
        this.showModalInput = false;
      } else {
        const url = `${actions.ACCREDITATION_PROCESS}/accreditation/approvedEvalTeam/${this.id}/1`;
        this.axiosGet(url)
          .then((res) => {
            this.hide = true;
            this.showModalInput = true;
            this.inputAprovedSystemGestion(this.id, "1");
          })
          .catch(({ error }) => {});
      }
    },

    fileChoosen(event) {
      if (event.target.files[0].size < 8111775) {
        this.file = event.target.files[0].name;
      } else {
        this.$toastr.e("EL archivo PDF no debe exceder los 2MB.");
      }
    },
    submit() {
      this.inputs.accreditation_application_id = this.accreditationId;
      this.inputs.evaluation_id = this.evaluationId;
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },
    afterSuccess(response) {
      if (response.status == 200) {
        this.$toastr.s("Registro actualizado exitosamente.");
      }
      this.$hub.$emit("reload-" + this.tableId);
      this.preloader = false;
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    closeAddEditModal() {
      $("#director-area-modal").modal("hide");
      this.isAddEditModalActive = false;
    },
    returnPage() {
      window.location.href = `${actions.ACCREDITATION_PROCESS}/evaluationTeam?tab=Aceptar%20u%20Objetar%20Equipo`;
    },

    saveTransaction() {
      const url = `${actions.ACCREDITATION_PROCESS}/accreditation/saveGestionOec/${this.id}`;
      this.axiosGet(url)
        .then((res) => {
          this.$toastr.s("Registro sistema de gestión del OEC, almacenado.");
        })
        .catch(({ error }) => {
          this.$toastr.e("Estado del sistema no modificado, error.");
        });
    },

    process() {
      this.inputs.accreditation_application_id = this.accreditationId;
      this.inputs.evaluation_id = this.id;
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      const url = `/accreditations/process/evaluationTeam/update`;
      axiosPost(url, formData)
        .then((res) => {
          window.location.href = `${actions.ACCREDITATION_PROCESS}/evaluationTeam?tab=Aceptar%20u%20Objetar%20Equipo`;
        })
        .catch(({ error }) => {
          this.$toastr.e(res.data.message);
        });
    },
    saveObservationsDisaproved() {
      this.preloader = true;

      const url = `/accreditations/process/evaluationTeam/update`;
      this.inputs.accreditation_application_id = this.accreditationId;
      this.inputs.evaluation_id = this.id;
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.$toastr.s(res.data.message);
          this.getObservations();
        })
        .catch(({ error }) => {
          this.$toastr.e(res.data.message);
        });
    },

    getObservations() {
      let url = `/common/observations?evalTestId=${this.id}&status=303`;
      this.axiosGet(url).then((response) => {
        if (response.data.length > 0) {
          this.inputs.observations = response.data[0].observation;
        }
      });
    },
    openDeleteModal(deleteOption, deleteTitle) {
      this.deleteOption = deleteOption;
      this.deleteTitle = deleteTitle;
      this.deleteConfirmationModalActive = true;
    },
    cancelled() {
      this.deleteConfirmationModalActive = false;
    },
  },
};
</script>
